<template>
    <li>
        <Icon :type="usp.icon" :color="usp.color" />
        <div class="service-package-usp">
            <div class="service-package-usp-title">
                <span v-if="usp.title">{{ usp.title }}</span>
                <div v-if="usp.showBadge">
                    <Badge
                        :text="usp.badgePrice"
                        :color="usp.badgeColor"
                        class="service-package-usp-badge" />
                </div>
            </div>
            <TransitionExpand v-if="showDescription">
                <span class="service-package-usp-text" v-html="sanitize(usp.text)" />
            </TransitionExpand>
        </div>
    </li>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ServicePackageUSP } from '@ui/components/ServicePackage/ServicePackage.interfaces';
    import { sanitize } from '@shared/utils/sanitize';
    import Icon from '@ui/components/Icon/Icon.vue';
    import Badge from '@ui/components/Badge/Badge.vue';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';

    export default defineComponent({
        name: 'ServicePackageUSPItem',
        methods: { sanitize },
        components: {
            Icon,
            Badge,
            TransitionExpand,
        },
        props: {
            usp: {
                type: Object as PropType<ServicePackageUSP>,
                required: true,
            },
            showDescription: {
                type: Boolean,
                default: false,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward '../ServicePackage.scss';
</style>
